export enum MenuOptionFileManager {
    SEE_DETAIL_FILE = 1,
    ACTIVATE_FILE = 2,
    DESACTIVATE_FILE = 3,
    EDIT_FILE = 4,
    DELETE_FILE = 5,
}

export enum EditViewNavigate {
    TABLE = 1,
    DETAIL = 2
}